"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importStar(require("react"));
const TGPageLabelWrapper_1 = __importDefault(require("./TGPageLabelWrapper"));
const clsx_1 = __importDefault(require("clsx"));
const core_1 = require("@material-ui/core");
const Common_1 = require("../FormFields/Common");
const lodash_1 = __importDefault(require("lodash"));
const TGPageTextField = props => {
    const { readOnly, computed, oneLine, translateFunction = text => text } = props;
    const classes = (0, Common_1.useStyles)();
    const label = (react_1.default.createElement(TGPageLabelWrapper_1.default, { required: props.required, readOnly: readOnly, label: props.label, info: props.info, calculated: computed, oneLine: oneLine, translateFunction: translateFunction }));
    const [value, setValue] = (0, react_1.useState)(props.value);
    const debouncedSet = (0, react_1.useCallback)(lodash_1.default.debounce((val) => props.onChange(val), 500, { leading: false }), []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.TextField, Object.assign({ fullWidth: true, InputLabelProps: {
                shrink: true,
                className: (0, clsx_1.default)(classes.labelShrink),
            } }, props, { value: value, onChange: (e) => { setValue(e.target.value); debouncedSet(e.target.value); }, label: label, className: classes.formElementWrapper, InputProps: {
                readOnly,
                disabled: readOnly,
            }, required: false }))));
};
exports.default = TGPageTextField;
//# sourceMappingURL=TGPageTextInputField.js.map